import React from 'react';
import { clsx } from 'clsx';

const glowColors = {
  red: 'glass-badge--red',
  blue: 'glass-badge--blue',
  green: 'glass-badge--green',
  gold: 'glass-badge--gold',
  navy: 'glass-badge--navy',
  white: 'glass-badge--white',
};

const sizes = {
  sm: 'glass-badge--sm',
  md: 'glass-badge--md',
  lg: 'glass-badge--lg',
};

export const GlassBadge = ({
  children,
  glow = 'blue',
  size = 'md',
  pulse = false,
  className,
}) => {
  return (
    <span
      className={clsx(
        'glass-badge',
        glowColors[glow],
        sizes[size],
        pulse && 'glass-badge--pulse',
        className
      )}
    >
      {children}
    </span>
  );
};

export default GlassBadge;
